import * as React from 'react';

export class Footer extends React.Component {

  public render() {
    return (
      <>
        <div className="row mt-2">
          <div className="col-12 text-center">
            V3.12 Last update: 2026-01-01
          </div>
        </div>
        <div className="row">
          <div className="col-12 text-center">
            <a href={"mailto:" + atob("Y3NhYmEuZGF2aWRAY3N1emRpLmh1")}>Feedback</a>
            &nbsp;|&nbsp;
            <a href="https://netto.csuzdi.hu" target="_blank">Nettó bér kalkulátor</a>
            &nbsp;|&nbsp;
            <a href="https://hitel.csuzdi.hu" target="_blank">Hitel kalkulátor</a>
          </div>
        </div>
      </>
    )
  }
}


// WEBPACK FOOTER //
// ./src/Footer.tsx